import { Component, OnInit } from '@angular/core';
import { SttTableComponent } from '../../../../shared/components/stt-table/stt-table.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { finalize } from 'rxjs/operators';
import { EnzymesModel } from '../../../../shared/entities/enzimes.model';
import { EnzymesService } from '../../../../shared/services/app/enzymes.service';
import { EnzymesAddEditComponent } from '../enzymes-add-edit/enzymes-add-edit.component';

@Component({
  selector: 'app-enzymes-action-table',
  templateUrl: './enzymes-action-table.component.html',
  styleUrls: ['./enzymes-action-table.component.scss']
})
export class EnzymesActionTableComponent implements OnInit {

    public data: EnzymesModel;
    public table: SttTableComponent;
    public ref: DynamicDialogRef;
    public loading = true;

    constructor(
        public dialogService: DialogService,
        public confirmationService: ConfirmationService,
        public primengConfig: PrimeNGConfig,
        public itemService: EnzymesService,
        public messageService: MessageService,
        private validationMessageService: ValidationMessageService,
    ) {

    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
    }

    setParams(entity: EnzymesModel): void {
        this.data = entity;
    }

    setTableReference(table: SttTableComponent): void
    {
        this.table = table;
    }


    showDialog() {
        this.ref = this.dialogService.open(EnzymesAddEditComponent, {
            header: 'Modificare Enzime',
            width: '30%',
            contentStyle: {'max-height': '70vh'},
            baseZIndex: 10000,
            closeOnEscape: false,
            data: this.data,
        });

        this.ref.onClose.subscribe((enzyme: EnzymesModel) => {
            if (enzyme) {
                this.table.refresh();
            }
        });
    }


    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Enzime',
            message: 'Sunteti sigur ca doriti sa stergeti aceasta enzima?',
            key: 'deleteEnzyme',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Enzima a fost stearsa cu success!'
                });
            });
    }
}
